module.exports = __webpack_public_path__ + "static/media/return-car.79c5f682.png";